import React from 'react'
import {Modal} from '@therms/atalaya'
import {SetDutyStatus} from '@src/modules/Users/shared/SetDutyStatus'

interface SetStatusModalProps {
  closeHandler: () => void
  onComplete: () => void
  userId: string
}

function SetUserStatusModal({
  closeHandler,
  onComplete,
  userId,
}: SetStatusModalProps) {
  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header="Set Duty Status"
      outsideClickClose
      showClose
    >
      <SetDutyStatus onComplete={onComplete} userId={userId} />
    </Modal>
  )
}

export {SetUserStatusModal}
